import { CONTINENT } from '../constants/types';

export const setContinent = (continent) => ({
  type: CONTINENT,
  continent: continent
});